module.exports = __webpack_public_path__ + "img/success.43375a63.svg";